import React, {useState} from 'react';
import TextField, {TextFieldProps} from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';


const PasswordField = (props: TextFieldProps) => {
  const [showingPassword, setShowingPassword] = useState(false);
  const toggleShowingPassword = () => setShowingPassword(p => !p);
  return (
    <TextField
      type={showingPassword ? 'text' : 'password'}
      InputProps={{
        endAdornment: <InputAdornment position="end">
          <IconButton
            disabled={props.disabled}

            onClick={toggleShowingPassword}
            onMouseDown={toggleShowingPassword}
            edge="end"
          >
            {showingPassword ? <Visibility/> : <VisibilityOff/>}
          </IconButton>
        </InputAdornment>,
      }}
      variant="outlined"
      value={props.value}
      onChange={props.onChange}
      label={props.label}
      disabled={props.disabled}
      error={props.error}
      onKeyPress={props.onKeyPress}
    />
  );
};

export default PasswordField;
